import { useQuery } from 'react-query'
import { fetchDonation, deserializeDonation } from 'supporticon/api/donations'

export const useDonation = (donationId, options = {}) => {
  const {
    deserializeMethod = deserializeDonation,
    refetchInterval,
    staleTime = 30000
  } = options

  return useQuery(
    ['donation', donationId],
    () => fetchDonation(donationId).then(deserializeMethod),
    {
      enabled: !!donationId,
      refetchInterval,
      staleTime
    }
  )
}

export default useDonation
